'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
function diceRotate() {
    'ngInject';

    return {
        restrict: 'A',
        link: function link(scope, element, attrs) {
            var speed = 0.1;
            var scale = 1;
            var degrees = 0;
            var transformer = function transformer() {
                var rScale = 'scale(' + scale + ')';
                var r = 'rotate(' + degrees + 'deg)';
                element.css({
                    '-moz-transform': r + ' ' + rScale,
                    '-webkit-transform': r + ' ' + rScale,
                    '-o-transform': r + ' ' + rScale,
                    '-ms-transform': r + ' ' + rScale,
                    'transition': 'all linear ' + speed + 's'
                });
            };
            scope.$watch(attrs.speed, function (newSpeed) {
                return speed = 1 - newSpeed;
            });
            scope.$watch(attrs.scale, function (newScale) {
                scale = newScale !== void 0 ? newScale : scale;
                transformer();
            });
            scope.$watch(attrs.degrees, function (newDegrees) {
                degrees = newDegrees !== void 0 ? newDegrees : degrees;
                transformer();
            });
        }
    };
}
exports.default = diceRotate;


// WEBPACK FOOTER //
// ./client/app/common/directives/diceRotate.directive.js